<template>
  <div class="article section">
    <BreadCreamVue :data="BreadCreamData" />
    <h1 class="article-title" v-text="data.title"></h1>
    <div class="article-content">
      <video :src="data.url" controls  :poster="data.poster" class="v-del"></video>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import BreadCreamVue from "../../components/BreadCream.vue";
import { vlist } from "./index";

export default defineComponent({
  name: "VideoDetail",
  components: {
    BreadCreamVue,
  },
  setup(props, ctx) {
    const id = ctx.root.$route.params.id;
    const data = computed(() => {
      const found = vlist.find(it => it.id == id)
      return found || {}
    })



    const BreadCreamData = computed(() => {
      return [
        {
          title: "VIDEOS",
          to: "/videos",
        },
        {
          title: data.value.title,
          to: "",
        },
      ];
    });

    return { data, BreadCreamData};
  },
});
</script>
<style lang="scss">
.article {
  overflow: hidden;

  .article-title {
    font-size: 22px;
    font-weight: 600;
    color: #231916;
    line-height: 30px;
    text-align: center;
    margin: 40px 40px 20px;
    overflow: hidden;
  }

  .publish-time {
    text-align: center;
    font-size: 14px;
    color: #666;
    line-height: 2;
    margin-bottom: 30px;
  }

  .article-content {
    font-size: 14px;
    line-height: 1.8em;
    padding-bottom: 150px;
    text-align: center;

    p {
      margin-bottom: 1em;
    }

    img {
      margin: 0 auto;
      display: block;
    }

    video{
      max-width: 1000px;
    }
  }
}
</style>
